module.exports = __webpack_public_path__ + "images/embed/gray_down_arrow.gif";